import React from "react";
import { pageTitle } from "../PageTitle";
import Privacy from "../Services/Privacy";


const PrivacyPolicy = () => {
  pageTitle("REICO");
  return(
    <>
    <Privacy />
    </>
  )
};

export default PrivacyPolicy;
